import "./Components/Atoms"
import "./Components/Molecules"
import "./Components/Organisms"
import {applyNavigationToggler} from "./Components/Molecules/NavigationToggler";

window.addEventListener('DOMContentLoaded', () => {
    const nodesList = document.querySelectorAll('[data-component="NavigationToggler"]');

    if (nodesList.length) {
        nodesList.forEach(element => {
            applyNavigationToggler(element);
        });
    }
});
